import { ContentLanguage, Language } from 'codegen/types'

import { env } from './algolia'

export const algoliaContentIndex = env(
  process.env.NEXT_PUBLIC_CONTENT_ALGOLIA_INDEX || process.env.VITE_ALGOLIA_INDEX,
  'NEXT_PUBLIC_CONTENT_ALGOLIA_INDEX or VITE_ALGOLIA_INDEX is not set',
)

export const algoliaContentIndexNewest = `${algoliaContentIndex}${
  algoliaContentIndex.includes('trending') ? '' : '_trending'
}_newest`
export const algoliaContentIndexOldest = `${algoliaContentIndex}${
  algoliaContentIndex.includes('trending') ? '' : '_trending'
}_oldest`

export const DEFAULT_ALGOLIA_LANGUAGE = ContentLanguage.LanguageEn

export enum AlgoliaLanguage {
  en = 'LANGUAGE_EN',
  fr = 'LANGUAGE_FR',
  de = 'LANGUAGE_DE',
  es = 'LANGUAGE_ES',
  it = 'LANGUAGE_IT',
  pt = 'LANGUAGE_PT_BR',
  nl = 'LANGUAGE_NL',
  pl = 'LANGUAGE_PL',
}

export type AlgoliaTranslatedString = Record<ContentLanguage, string>

export interface AlgoliaContentHit {
  __position: number
  __queryID: string
  _highlightResult?: {
    title: Record<ContentLanguage, { value: string }>
  }
  authorId: string
  objectID: string
  slug: AlgoliaTranslatedString
  thumbnail: { url: string; width: number; height: number }
  previewMobile: { url: string; width: number; height: number }
  previewDesktop: { url: string; width: number; height: number }
  title: AlgoliaTranslatedString
}

export interface AlgoliaLegacyProductHit {
  aiPrompt?: string
  type: ProductType
  category: string[]
  tags: string[]
  hasPua: boolean
  isExclusive: boolean
  image: string
  url: string
  designer: {
    designerId: number
    designerName: string
    designerUrl: string
    isPremium?: boolean
    premiumLegalEntity?: string
  }
  price: number | string
  usedFonts: string[]
  outsideSubscription: boolean
  hasPod: boolean
  hasPromotions: boolean
  date: number | string
  regularPrice: string | undefined | boolean
  name_en: string
  description_en: string
  name_es: string
  description_es: string
  name_de: string
  description_de: string
  name_fr?: string
  description_fr?: string
  name_it?: string
  description_it?: string
  name_nl?: string
  description_nl?: string
  name_pl?: string
  description_pl?: string
  name_pt?: string
  description_pt?: string
  objectID: string | number
  extraSettings?: {
    level: string
    source: string
    sparkModelType?: string
    sparkModelVersion?: string
    sparkType?: string
  }
  __position: number
  __queryID: string
  isActiveBundle?: boolean
  endDate?: number
}

export enum ProductType {
  FONTS = 'Fonts',
  GRAPHICS = 'Graphics',
  CRAFTS = 'Crafts',
  EMBROIDERY = 'Embroidery',
  BUNDLES = 'Bundles',
  CLASSES = 'Classes',
  COMMUNITY = 'Community',
  SVG_3D = '3D SVG',
}

export function mapLocaleToLegacyProductTranslation(language: Language) {
  switch (language) {
    case Language.Es: {
      return {
        name: 'name_es' as const,
        title: 'title_es' as const,
      }
    }
    case Language.De: {
      return {
        name: 'name_de' as const,
        title: 'title_de' as const,
      }
    }
    case Language.Fr: {
      return {
        name: 'name_fr' as const,
        title: 'title_fr' as const,
      }
    }
    case Language.It: {
      return {
        name: 'name_it' as const,
        title: 'title_it' as const,
      }
    }
    case Language.Nl: {
      return {
        name: 'name_nl' as const,
        title: 'title_nl' as const,
      }
    }
    case Language.Pl: {
      return {
        name: 'name_pl' as const,
        title: 'title_pl' as const,
      }
    }
    case Language.Pt: {
      return {
        name: 'name_pt' as const,
        title: 'title_pt' as const,
      }
    }
    // oxlint-disable-next-line unicorn/no-useless-switch-case
    case Language.En:
    default: {
      return {
        name: 'name_en' as const,
        title: 'title_en' as const,
      }
    }
  }
}
